/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Pick_LoadingInputs */

const en_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finding your starting portfolios…`)
};

const de_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Startportfolios werden zusammengestellt…`)
};

const pt_br2_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando seus portfólios iniciais…`)
};

const tr_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç portföyleriniz hazırlanıyor…`)
};

const zh_cn2_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在查找适合您的起始投资组合…`)
};

const zh_hk2_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在尋找適合您的起始投資組合…`)
};

const ko_kr2_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시작 포트폴리오를 찾고 있어요…`)
};

const ru_ru2_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подбираем стартовые портфели…`)
};

const es_419_onboarding_v1_pick_loading = /** @type {(inputs: Onboarding_V1_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando tus portafolios iniciales…`)
};

/**
* | output |
* | --- |
* | "Finding your starting portfolios…" |
*
* @param {Onboarding_V1_Pick_LoadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_loading = /** @type {((inputs?: Onboarding_V1_Pick_LoadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_LoadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_loading(inputs)
	if (locale === "de") return de_onboarding_v1_pick_loading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_loading(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_loading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_loading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_loading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_loading(inputs)
	return es_419_onboarding_v1_pick_loading(inputs)
});